(() => {
  const root = document.querySelector('.os-support');
  if (!root) return;
  const openAnchor = () => {
    const id = location.hash.slice(1);
    const target = id && document.getElementById(id);
    if (target && root.contains(target) && target.matches('details')) target.open = true;
  };
  openAnchor();
  window.addEventListener('hashchange', openAnchor);
  root.querySelectorAll('a[href^="#support-"]').forEach(link => {
    link.addEventListener('click', () => {
      const target = document.getElementById(link.hash.slice(1));
      if (target && target.matches('details')) target.open = true;
    });
  });
})();
